"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDocumentData = void 0;
const config_1 = require("../config");
const pageFrameService_1 = require("../pageFrameService");
const sharedSessionState_1 = require("../sharedSessionState");
/**
 * Return data from Page Frame service.
 * @param {object} ctx Application Context
 * @param {require('http').IncomingMessage} ctx.req HTTP request object
 * @param {object} ctx.req.headers HTTP request object
 * @param {object} [ctx.pageFrameOverrides] Page Frame overrides
 * @param {number} [ctx.pageFrameOverrides.regionalizedLinks]
 * @param {object} opts
 * @param {string|null} [opts.pfsHost]
 * @param {string|null} [opts.s3sHost]
 * @param {string | null} [opts.headerVersion]
 * @param {Record<string, unknown> | null} [opts.requestHeaders]
 * @param {boolean | null} [opts.deferDropdowns]
 * @param {string|null} [opts.gaTrackingId]
 * @param {boolean|null} [opts.includeZsg]
 * @param {boolean|number|null} [opts.regionalizedLinks] Regionalize topnav links using s3s?
 * @param {boolean|null} [opts.includeComscore]
 * @param {boolean|null} [opts.includeFonts]
 * @param {boolean|null} [opts.includeGTM]
 * @param {boolean|null} [opts.deferScripts]
 * @param {boolean|null} [opts.staticMarkup]
 *
 * @returns {Object} PFS Data
 */
async function getDocumentData(ctx, opts) {
    const { deviceType, guid, loggedIn, loginMemento, pageFrameConfig, pfsHost, requestId, s3sHost, sid, ssid, zuid, profiles, userType, } = (0, config_1.getPageFrameConfig)(ctx && ctx.req, opts);
    const headerVersion = opts && opts.headerVersion;
    // Use this in case options like regionalizedLinks need to be passed during
    // Document.getInitialProps.
    const { pageFrameOverrides } = ctx;
    let region;
    let gaTrackingId;
    let includeZsg;
    let deferDropdowns;
    let requestHeaders;
    let includeComscore;
    let includeFonts;
    let includeGTM;
    let deferScripts;
    let staticMarkup;
    if (opts &&
        opts.regionalizedLinks === true &&
        pageFrameOverrides &&
        typeof pageFrameOverrides.regionalizedLinks === 'number') {
        region = pageFrameOverrides.regionalizedLinks;
    }
    else if (opts && opts.regionalizedLinks === true) {
        const ipAddr = (ctx && ctx.req && ctx.req.headers && ctx.req.headers['x-client-ip']) || null;
        const sharedSessionState = await (0, sharedSessionState_1.getSharedSessionState)(guid, s3sHost, { ipAddr });
        region = sharedSessionState.regionId;
        // eslint-disable-next-line no-restricted-globals
    }
    else if (opts && !isNaN(Number(opts.regionalizedLinks))) {
        // number/regionId was passed in regionalizedLinks
        region = opts.regionalizedLinks;
    }
    /* eslint-disable prefer-destructuring */
    if (opts && opts.gaTrackingId) {
        gaTrackingId = opts.gaTrackingId;
    }
    if (opts) {
        includeZsg = opts.includeZsg;
        requestHeaders = opts.requestHeaders;
        deferDropdowns = opts.deferDropdowns;
        includeComscore = opts.includeComscore;
        includeFonts = opts.includeFonts;
        includeGTM = opts.includeGTM;
        deferScripts = opts.deferScripts;
        staticMarkup = opts.staticMarkup;
    }
    /* eslint-enable prefer-destructuring */
    const pageFrameResponse = await (0, pageFrameService_1.getPageFrameServiceData)({
        gaTrackingId,
        deviceType,
        guid,
        headerVersion,
        loginMemento,
        pfsHost,
        region,
        requestHeaders,
        requestId,
        sid,
        ssid,
        zuid,
        profiles,
        userType,
        includeZsg,
        deferDropdowns,
        includeComscore,
        includeFonts,
        includeGTM,
        deferScripts,
        staticMarkup,
    });
    return {
        guid,
        requestId,
        loggedIn,
        config: { ...pageFrameConfig },
        ...pageFrameResponse,
    };
}
exports.getDocumentData = getDocumentData;
